import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { DataFetcher } from '@provider-portal/common/api/apiFetcher/createFetcher';
import {
  GetMenuItemsForProviderActiveMenuRequest,
  GetMenuItemsForProviderActiveMenuResponse,
  TranslatableField,
} from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/apis';
import { ListItemElementPriceDetails } from '@provider-portal/menu-common/components/ItemsList/SelectItemsDialogFC';

export interface ListItemElement {
  id: string;
  label: string;
  name: TranslatableField;
  imageUrl?: string;
  priceDetails: ListItemElementPriceDetails;
  isDisabled: boolean;
  disableReason?: string;
  product_id: string;
}

export function useMenuItemsLoader(
  providerId: number,
  menuItemsFetcher: DataFetcher<
    GetMenuItemsForProviderActiveMenuResponse,
    [request: GetMenuItemsForProviderActiveMenuRequest]
  >,
  exclusionTags: string[],
  exclusionMessage: string,
): ListItemElement[] {
  const intl = useIntl();
  const [itemListData, setItemListData] = useState([]);

  useEffect(() => {
    menuItemsFetcher
      .fetch({ provider_id: providerId })
      .then((data) => {
        if (!data) {
          return;
        }
        const exclusionTagsSet = new Set(exclusionTags);
        const menuItems = data.items_data.map((item) => {
          const selectedLocale = intl.locale;
          const fallBackLocale = 'en-US' in item.name ? 'en-US' : Object.keys(item.name)[0];
          const itemLabelName = item.name[selectedLocale]
            ? item.name[selectedLocale]
            : item.name[fallBackLocale];
          return {
            id: item.global_stable_context_id,
            product_id: item.product_id,
            label: itemLabelName,
            name: item.name,
            imageUrl: item.icon,
            priceDetails: {
              price: item.price,
              currency: item.currency,
              price_str: item.price_str,
            },
            isDisabled: item.tags.some((tag) => exclusionTagsSet.has(tag)),
            disableReason: exclusionTags.length ? exclusionMessage : undefined,
          };
        });
        setItemListData(menuItems);
      })
      .catch(() => {});
  }, [exclusionMessage, exclusionTags, intl, menuItemsFetcher, providerId]);
  return itemListData;
}
